import { Helmet } from 'react-helmet-async';

/**
 * JsonLd — drop into any page to inject schema.org structured data.
 * Pass a single object or an array of objects.
 *
 * Examples:
 *   <JsonLd data={{ "@context": "https://schema.org", "@type": "Article", ... }} />
 *   <JsonLd data={[orgSchema, jobSchema]} />
 */
const JsonLd = ({ data }) => {
  if (!data) return null;
  const payloads = Array.isArray(data) ? data : [data];
  return (
    <Helmet>
      {payloads.map((payload, idx) => (
        <script key={idx} type="application/ld+json">
          {JSON.stringify(payload)}
        </script>
      ))}
    </Helmet>
  );
};

export default JsonLd;
